import type { LogFilter, LogGroup, OversightPlan } from '../../../api/safetyRounds';

export const LOG_GROUPS: LogGroup[] = ['ALL', 'PLANS', 'ROUNDS', 'DEVIATIONS', 'TEMPLATES'];

export const STATUS_COLORS: Record<OversightPlan['status'], 'success' | 'warning' | 'danger' | 'info'> = {
  onTrack: 'success',
  soon: 'warning',
  overdue: 'danger',
  awaitingSignature: 'info',
  sentBack: 'warning',
};

/** The period must end on or after it starts */
export const periodError = (filter: LogFilter) => Boolean(filter.from && filter.to && filter.from > filter.to);

/** The filter as the PDF page reads it from the address */
export const filterFrom = (params: URLSearchParams): LogFilter => {
  const group = params.get('group') as LogGroup | null;
  return {
    group: group && LOG_GROUPS.includes(group) ? group : 'ALL',
    from: params.get('from') ?? '',
    to: params.get('to') ?? '',
  };
};

/** «vernerunder-logg-2026-10-01-2026-10-31.pdf» */
export const logFileName = (filter: LogFilter, extension: 'pdf' | 'csv') => {
  const period = [filter.from, filter.to].filter(Boolean).join('-');
  return `vernerunder-logg${period ? `-${period}` : ''}.${extension}`;
};

/** «02.10.2026 14:05», the time in Norway */
export const logTime = (at: string, language: string) =>
  new Intl.DateTimeFormat(language === 'en' ? 'en-GB' : 'nb-NO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Oslo',
  })
    .format(new Date(at))
    .replace(',', '');

export const saveFile = (blob: Blob, name: string) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  anchor.click();
  URL.revokeObjectURL(url);
};
